export enum AUTH_TYPE {
  SAML20 = 1,
  DAVINCI = 2
}
